import React from "react";
import PropTypes from "prop-types";
import Header from "../header/header";
import Footer from "../footer/footer";
import { HubspotProvider } from "@aaronhayes/react-use-hubspot-form";

const Layout = ({ children }) => {
  if (typeof window !== "undefined") {
    require("smooth-scroll")('a[href*="#"]');
  }

  return (
    <HubspotProvider>
      <Header siteTitle={`Collar para cuidar mi perro`} />
      <main>{children}</main>
      <Footer />
    </HubspotProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
